import React, { useEffect, useState } from 'react';

function Paginator({ currentPage, lastPage, onPageChange }) {
    const [pages, setPages] = useState([]);

    useEffect(() => {
        getPages();
    }, [currentPage, lastPage]);

    function changePage(page) {
        getPages();
        onPageChange(page);
    }

    function getPages() {
        let pages = [];
        let middleNumber = currentPage;
        if (currentPage < 3) middleNumber = 3;
        if (currentPage > lastPage - 2) middleNumber = lastPage - 2;
        for (let i = middleNumber - 2; i <= middleNumber + 2; i++) {
            if (i > 0 && lastPage >= i) pages.push(i);
        }
        setPages(pages);
    }

    function getPageItems() {
        return pages.map((page) => (
            <li className={'page-item ' + (currentPage === page ? 'active' : '')} key={page}>
                <a onClick={() => changePage(page)} rel="next" key={page}>
                    <span className="page-link">{page}</span>
                </a>
            </li>
        ));
    }

    return (
        <ul className="pagination">
            <li className={'page-item ' + (currentPage === 1 ? 'disabled' : '')}>
                <a onClick={() => changePage(currentPage > 1 ? currentPage - 1 : 1)} rel="prev">
                    <span className="page-link">{'«'}</span>
                </a>
            </li>
            {getPageItems()}
            <li className={'page-item ' + (currentPage === lastPage ? 'disabled' : '')}>
                <a onClick={() => changePage(lastPage > currentPage ? currentPage + 1 : lastPage)}>
                    <span className="page-link">{'»'}</span>
                </a>
            </li>
        </ul>
    );
}

export default Paginator;

// TODO: make a test with onPageChange manipulation
